import { createContext, createElement, useContext } from 'react'
import type { ReactNode } from 'react'
import { skipToken } from '@reduxjs/toolkit/query'
import { useGetRunFileDownloadUrlQuery } from '../../store/customWorkflow/customWorkflows'
import type { WorkflowOutputFile } from './outputTypes'

interface RunFileContextValue {
  accountId: string
  workflowId: string
  runId: string
}

export interface ResolvedFileUrl {
  url: string | null
  isError: boolean
  resolved: boolean
}

const RunFileContext = createContext<RunFileContextValue | null>(null)

export const RunFileProvider = ({ value, children }: { value: RunFileContextValue; children: ReactNode }) =>
  createElement(RunFileContext.Provider, { value }, children)

export const useRunFileContext = () => useContext(RunFileContext)

export const useResolvedFileUrl = (file: WorkflowOutputFile, options?: { asAttachment?: boolean }): ResolvedFileUrl => {
  const ctx = useRunFileContext()
  const canResolve = ctx !== null && file.relatedId !== null
  const { data, isError } = useGetRunFileDownloadUrlQuery(
    canResolve
      ? { accountId: ctx!.accountId, workflowId: ctx!.workflowId, runId: ctx!.runId, fileId: file.relatedId!, asAttachment: options?.asAttachment }
      : skipToken,
  )
  if (canResolve) {
    return { url: data?.url ?? null, isError, resolved: !!data?.url }
  }
  return { url: file.url, isError: false, resolved: false }
}
